import * as React from 'react';
import './index.css';
import { withTranslation, i18nClient, I18nextProvider } from '@sailor/i18n-mach-pro';
import { connect } from '@wmfe/mach-pro-store';
import { RootState } from '@/src/pages/homepage/home_page_main/models/store';
import AdReport from '@wmfe/ad-report-machpro';
import { View } from '@wmfe/mach-pro-components-react';
import { reportBizCardMetrics, findTargetFromMatrix } from '@/src/utils/bizCardReporter';
import { ModuleItemProps } from '../common/interface';
import {
  reportProductCardMc, reportProductCardMv, reportProductCardUnfoldButtonMc, reportProductCardUnfoldButtonMv, setCid
} from './lxReport';
import { ProductCardMc, ProductCardMv } from './constant';
import resources from './locales/resources';
import { HIT_AD, reportChargeMc, reportChargeMv } from '../common/BaseComponent/adReport';
import FeedsGoldenShopCard from './GoldenShopCard';

const SLCommon = Mach.requireModule('SLCommon');
export const GoldenProductCardTempID = 'mach_pro_sailor_c_home_page_feeds_card_golden';

const mapStateToProps = (state: RootState) => ({
  filterPanelData: state.global.filterPanelData,
  pageSource: state.global.pageSource,
  feedAPIData: state.global?.feedAPIData,
  pageNo: state.global?.pageNo,
});

type BaseIProps = ReturnType<typeof mapStateToProps>;

interface IProps extends BaseIProps, ModuleItemProps {
  setGoldenCardMVReport: Function;
  goldenCardMVList: string[];
  longPressItemCard?: (apiData) => void;
}
interface IState {
}
i18nClient.init({
  fallbackLng: 'zh-HK',
  resources,
});
class FeedsCard extends React.Component<IProps, IState> {
  keyDomRef: any = null;
  observer: any = null;

  constructor(props) {
    super(props);
    const cid = this.props.apiData.log_info.cid || ' -999';
    setCid(cid);
    this.initAdReport();
  }

  componentWillUnmount() {
    this.removeObserver();
  }

  isEnvProdOrSt = () => {
    if (SLCommon) {
      const { env } = SLCommon.getEnv();
      return env === 'Prod' || env === 'Stage';
    }
  }

  initAdReport = () => {
    if (globalThis.isInitAd) {
      return;
    }
    if (this.props.apiData?.json_data?.adInfo?.hitAd === HIT_AD) {
      //https://km.sankuai.com/collabpage/1443226541
      const isProdOrSt = this.isEnvProdOrSt();
      // @ts-ignore
      AdReport.init({
        mads: {
          env: isProdOrSt ? 'prod' : 'test'
        }
      });
      globalThis.isInitAd = true;
    }
  }

  removeObserver = () => {
    if (!this.observer) {
      return;
    }

    this.observer?.unSubscribe?.();
  }

  lxReportOnClick = () => {
    const { pageLogData, apiData } = this.props;
    reportProductCardMc(apiData?.json_data, this.props.apiData?.indexPath.item, pageLogData);
    reportChargeMc(ProductCardMc, this.props.apiData?.json_data?.adInfo);
  }

  lxReportOnShow = (apiData) => {
    const { goldenCardMVList, setGoldenCardMVReport, pageLogData } = this.props;
    const hasReported = goldenCardMVList.includes(apiData.data_id);
    if (!hasReported) {
      reportProductCardMv(
        apiData?.json_data,
        apiData?.indexPath.item,
        pageLogData
      );
      if (apiData?.json_data?.shouldShowMoreTags) {
        reportProductCardUnfoldButtonMv(
          apiData?.json_data,
          apiData?.indexPath.item,
          { ...pageLogData, expand_status: 1 } // 初次展示必定是待点击展开状态
        );
      }
      reportChargeMv(ProductCardMv, apiData?.json_data?.adInfo);
      setGoldenCardMVReport(apiData.data_id);
      this.attrChecker();
    }
  }

  // 1代表点击后展开，0代表点击后收起
  lxReportOnUnfoldButtonClick = (status: 0 | 1) => {
    const { pageLogData, apiData } = this.props;
    reportProductCardUnfoldButtonMc(
      apiData?.json_data,
      apiData?.indexPath.item,
      { ...pageLogData, expand_status: status }
    );
  }

  attrChecker = (): void => {
    const data = this.props?.apiData?.json_data;
    const shopMainPicMissing = data?.shopMainPicUrl !== null && data?.shopMainPicUrl ? 0 : 1;
    const shopNameMissing = findTargetFromMatrix(data?.content, 'shopName')?.name ? 0 : 1;
    const shopJumpUrlMissing = data?.scheme ? 0 : 1;
    reportBizCardMetrics({
      params: { shopJumpUrlMissing, shopNameMissing, shopMainPicMissing },
      tags: {
        channel: '通用商卡'
      }
    });
  }

  render() {
    this.initAdReport();
    const { apiData } = this.props;
    const { json_data, layout_info, isExpand } = apiData || {};
    const {
      margin_top, margin_bottom, margin_left, margin_right
    } = layout_info || {};
    return (
      <View
        className="container" style={{
          marginTop: margin_top || 0, marginBottom: margin_bottom || 12, marginLeft: margin_left || 12, marginRight: margin_right || 12, flexDirection: 'column'
        }}
        ref={(ref) => {
          this.keyDomRef = ref;
        }}
        onView={(visable) => {
          if (visable) {
            this.lxReportOnShow(apiData);
          }
        }}
      >
        <FeedsGoldenShopCard
          data={json_data}
          lxReportOnClick={this.lxReportOnClick}
          lxReportOnUnfoldButtonClick={this.lxReportOnUnfoldButtonClick}
          isExpand={isExpand}
          cardLayout={layout_info}
          indexPath={this.props.apiData?.indexPath}
          longPressItemCard={() => {
            this.props.longPressItemCard?.(apiData);
          }}
          cid={this.props.apiData.log_info.cid || ' -999'}
          dataId={apiData.data_id || ''}
        />
      </View>
    );
  }
}

const GoldenProductCard = connect(mapStateToProps)(withTranslation('', {
  withRef: true
})(FeedsCard));

export default (props) => (
  <I18nextProvider i18n={i18nClient}>
    <GoldenProductCard {...props} />
  </I18nextProvider>
);
